<template>
  <div class="signin container">
    <v-card outlined>
      <v-card-title>로그인</v-card-title>
      <v-form id="signin-form" class="px-4" lazy-validation @submit.prevent="login">
        <v-text-field 
          label="이메일" required outlined
          :rules="emailRules" v-model="email"></v-text-field>
        <v-text-field
          type="password" label="비밀번호" required outlined
          v-model="password"></v-text-field>
        <p class="red--text" v-if="feedback">{{ feedback }}</p>
        <v-btn 
          type="submit" color="green" class="mb-5" outlined dark 
          form="signin-form" @click="login">로그인</v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'signin',
  data() {
    return {
      feedback: '',
      email: '',
      emailRules: [
        v => !!v || '이메일을 입력해주세요',
        v => /.+@.+\..+/.test(v) || '이메일 형식에 맞지 않습니다',
      ],
      password: ''
    }
  },
  methods: {
    login() {
      if(this.email && this.password) {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            this.$router.push({ name : 'home' })
          })
          .catch(err => {
            this.feedback = err.message
          })
        this.feedback = ''
      } else {
        this.feedback = '모든 항목의 값을 입력해주세요'
      }
    }
  }
}
</script>

<style>
.signin {
  margin: 12vh auto;
  max-width: 50%;
}

.signin .text-field {
  margin: 5 auto !important;
}
</style>